import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { CreditDetails, AddCredit, CreditPayment, SignCredit, PayCredit, EarlyRepaymentRequest, AbsenceProtocol } from './Credits';
import { AddBorrower, BorrowerCkr, BorrowerDetails } from './Borrowers';
import { FranchiseeDetails, AddFranchisee } from './Franchises';
import { EmployeeDetails, AddEmployee } from './Employee';
import { OfficeDetails, AddOffice } from './Office';
import { ActionDetails } from './Actions';
import { AddPartner, PartnerDetails } from './Partners';
import { ExternalCreditDetails, AddExternalCredit } from './ExternalCredit';
export var PrivateRoutes = function PrivateRoutes(role) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    credits: {
      internal: [{
        url: '/credits/new',
        label: 'Създай кредит',
        component: AddCredit
      }, {
        label: 'Детайли за кредита',
        url: '/credits/details/:creditId',
        component: CreditDetails
      }, {
        url: '/credits/payment/:creditId',
        label: 'Вноска по кредит',
        component: CreditPayment
      }, {
        label: 'Подпис на документи',
        url: '/credits/sign/:creditId',
        component: SignCredit
      }, {
        label: 'Изплати кредит',
        url: '/credits/pay/:creditId',
        component: PayCredit
      }, {
        label: 'Искане за предсрочно погасяване',
        url: '/credits/early-repayment-request/:creditId',
        component: EarlyRepaymentRequest
      }, {
        label: 'Протокол за констатиране на отсъствие',
        url: '/credits/absence-protocol/:creditId',
        component: AbsenceProtocol
      }]
    },
    borrowers: {
      internal: [{
        url: '/borrowers/new',
        label: 'Създай кредитополучател',
        component: AddBorrower
      }, {
        label: 'Детайли за кредитополучателя',
        url: '/borrowers/details/:borrowerIdNumber',
        component: BorrowerDetails
      }, {
        label: 'Провери ЦКР',
        url: '/borrowers/ckr/:borrowerIdNumber',
        component: BorrowerCkr
      }]
    }
  }, (role === null || role === void 0 ? void 0 : role.isAdminOrTenant) && {
    franchises: {
      internal: [{
        label: 'Създай кредитен посредник',
        url: '/franchises/new',
        component: AddFranchisee
      }, {
        label: 'Детайли за кредитният посредник',
        url: '/franchises/details/:franchisesId',
        component: FranchiseeDetails
      }]
    }
  }), (role === null || role === void 0 ? void 0 : role.isAdminOrTenant) && {
    employee: {
      internal: [{
        label: 'Детайли за служителя',
        url: '/employee/details/:employeeId',
        component: EmployeeDetails
      }, {
        label: 'Съдаване на служител',
        url: '/employee/new',
        component: AddEmployee
      }]
    }
  }), (role === null || role === void 0 ? void 0 : role.isAdminOrTenantOrOwnerOrManager) && {
    office: {
      internal: [{
        label: 'Детайли за офиса',
        url: '/office/details/:officeId',
        component: OfficeDetails
      }, {
        label: 'Съдаване на офис',
        url: '/office/new',
        component: AddOffice
      }]
    }
  }), (role === null || role === void 0 ? void 0 : role.isAdminOrTenantOrOwnerOrManager) && {
    actions: {
      internal: [{
        label: 'Детайли за действието',
        url: '/actions/details/:actionId',
        component: ActionDetails
      }]
    }
  }), (role === null || role === void 0 ? void 0 : role.isAdminOrTenantOrOwnerOrManager) && {
    partners: {
      internal: [{
        url: '/partner/new',
        label: 'Съдаване на партньор',
        component: AddPartner
      }, {
        url: '/partner/details/:partnerId',
        label: 'Детайли за партньор',
        component: PartnerDetails
      }]
    }
  }), (role === null || role === void 0 ? void 0 : role.isAdminOrTenant) && {
    externalCredit: {
      internal: [{
        label: 'Детайли за външния кредит',
        url: '/external-credit/details/:externalCreditId',
        component: ExternalCreditDetails
      }, {
        label: 'Създаване на външен кредит',
        url: '/external-credit/new',
        component: AddExternalCredit
      }]
    }
  });
};